import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab';

const ToggleLabel = styled.label`
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${tokens.color_text_default_le};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  padding: 0 12px;
  margin-bottom: 0;
  transition: all 0.1s ease-in-out;
  border-radius: 30px;
  white-space: nowrap;

  &:hover {
    cursor: pointer;
    background: ${tokens.color_background_2_le};
  }
`;

const ToggleInput = styled.input`
  position: absolute !important;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  width: 1px;
  border: 0;
  overflow: hidden;

  &:checked + label {
    background-color: ${tokens.color_background_1_le};
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  }

  &:disabled + label {
    opacity: 0.5;
  }
`;

/**
 * @deprecated Use { Switch } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/switch--docs
 */

const Toggle = ({ name, label, value, defaultChecked, onChange, disabled }) => {
  const id = `${name}-${value}`;
  return (
    <React.Fragment>
      <ToggleInput
        type="radio"
        name={name}
        id={id}
        defaultChecked={defaultChecked}
        onChange={(checked) => {
          if (checked) {
            onChange(value);
          }
        }}
        disabled={disabled}
      />
      <ToggleLabel htmlFor={id}>{label}</ToggleLabel>
    </React.Fragment>
  );
};

Toggle.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
};

Toggle.defaultProps = {
  defaultChecked: false,
  onChange: () => {},
};

export default Toggle;
